<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>用户名：</label>
                    <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>姓名：</label>
                    <el-input v-model="search_Obj.f_realname" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
                <el-button type="primary"  @click="addUser">添加</el-button>
                <el-button type="danger"  @click="delAll">删除</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                    <el-table-column prop="username" label="用户名" width="130"></el-table-column>
                    <el-table-column prop="realname" label="姓名" width="130"></el-table-column>
                    <el-table-column prop="org_name" label="所在机构" ></el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="170"></el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
        <DeviceUserSelect
            width="1200px"
            title="选择用户"
            :isshow="show_user_list"
            :device_type="device_type"
            :device_id="device_id"
            @setUser="setUser"
            @on-close="closeSelDialog">
        </DeviceUserSelect>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { addDeviceUser } from '@/api/deviceuser'
import DeviceUserSelect from "../user/deviceuserselect"

export default {
    name: 'deviceUserList',
    mixins: [listutil],
    components: {DeviceUserSelect},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        device_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        device_type: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_device_id = this.device_id;
            this.search_Obj.f_device_type = this.device_type;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '设备用户关联',
            menu_id: 9999,
            pagesize: 10,
            list_url: "/api/admin/deviceuser/list",
            search_Obj: {
                f_username: '',
                f_realname: '',
                f_device_id: '',
                f_device_type: '',
            },
            del_Obj:{
                url:'/api/admin/deviceuser/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            showflag: false,
            show_user_list: false,
            user_ids: '',
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        addUser(){
            this.show_user_list = true
        },
        setUser(user_ids){
            this.user_ids = user_ids
            addDeviceUser(this.device_type, this.device_id, this.user_ids).then(res=>{
                if (res.code == 1) {
                    this.$msgs(res.msg)
                } else {
                    this.$msg(res.msg)
                }
                this.closeSelDialog()
            })
        },
        closeSelDialog(){
            this.show_user_list = false
            this.getListData()
        },
    }
};
</script>